import { updateTenantObj } from "../../shared/interfaces/components/tenantList.interface";
import * as types from "./consts";

export const getTenantsListRequest = (payload?: string) => ({
  type: types.GET_TENANTS_LIST_REQUEST,
  payload,
});

export const getDetailsTenantRequest = (payload: string) => ({
  type: types.GET_TENANT_DETAIL_REQUEST,
  payload,
});

export const deleteTenantRowRequest = (payload: string) => ({
  type: types.DELETE_TENANT_ROW_REQUEST,
  payload,
});


export const deleteUserRowRequest = (paylaod: string) => ({
  type: types.DELETE_USER_V3_ROW_REQUEST,
  payload: paylaod,
})

export const updateTenantRowRequest = (payload: updateTenantObj) => ({
  type: types.UPDATE_TENANT_ROW_REQUEST,
  payload,
});

export const updateUserRowRequest = (payload: updateTenantObj) => ({
  type: types.UPDATE_USER_V2_ROW_REQUEST,
  payload,
});
